export const APP_URI = "/app";


export const CATEGORIES_URI = APP_URI + '/categories'; 
export const PRODUCTS_URI = APP_URI + '/products/';
export const PRODUCT_URI = APP_URI + '/product/';
export const COMFIRMED_URI = APP_URI + '/confirmed';

